// extracted by mini-css-extract-plugin
module.exports = {"confirmOverlayWrapper":"styles_confirmOverlayWrapper__cSrSh"};